import React from "react";
// import Home from "./pages/home";
import { Route, Routes } from "react-router-dom";
import Notfound from "./pages/notfound";
import QST from "./pages/qst";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<QST />} />
      <Route path="*" element={<Notfound />} />
    </Routes>
  );
}
